module.exports = __webpack_public_path__ + "media/images/golf-background-e1f750b318a5e2649aa9919f84a9ce4f.jpg";